$(document).ready(function() {


	//Mega Menu
	$('.hamburger-btn').off('click').on('click', function() {
		$(this).toggleClass('active');
		$('body').toggleClass('no-scroll');
		$('.mega_menu').slideToggle(300); 
	});

	$('ul.mega_main_menu li').off('click').on('click', function(e) {
		e.stopPropagation();
		var $this = $(this);
		$('ul.mega_main_menu li').not($this).removeClass('open');
		$this.toggleClass('open');
	});

	$('select#blog_filter').on('change', function() {
		let val = $(this).val();
		$('ul.blog-articles li.blog-articles__article').each(function() {
			let $li = $(this);
			let articleCategory = $li.find('article').data('category');

			if (val === "" || articleCategory == val) {
				$li.removeClass('hide');
			} else {
				$li.addClass('hide');
			}
		});
	});

	$('select#catalog_filter').on('change', function() {
		let val = $(this).val();
		
		$('ul.blog-articles li.blog-articles__article').each(function() {
			let $li = $(this);
			let articleCategory = $li.find('article').data('category');

			if (val === "" || articleCategory == val) {
				$li.removeClass('hide');
			} else {
				$li.addClass('hide');
			}
		});
	});


	
	const $productCards = $('ul.blog-articles li.blog-articles__article');

	function applyCustomFilters() {
		const selectedService = $('#work_filter_services').val();
		const selectedSector = $('#work_filter_sector').val();

		$productCards.each(function() {
			const $card = $(this);
			
			const cardServices = $card.find('article').data('services');
			const cardSector = $card.find('article').data('sector');

			if (cardServices == selectedService && cardSector == selectedSector || selectedService === '' || selectedSector === '') {
				$card.removeClass('hide');
			} else {
				$card.addClass('hide');
			}
		});
	}

	$('#work_filter_services, #work_filter_sector').on('change', applyCustomFilters);



    //in viewport 
	
		//columns
		var $h2 = $('h2');
        var $richtext = $('.rich-text__text');
		var $aside = $('section#shopify-section-template--21115362377816__main');
        var $img = $('img');
		var $window = $(window);
		
    
    function check_if_in_view() {
		  var window_height = $window.height();
		  var window_top_position = $window.scrollTop();
		  var window_bottom_position = (window_top_position + window_height);
			
			//animations box
			$.each($h2, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('fadein');
			} 
		  });


          $.each($richtext, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('fadein');
			} 
		  });


           $.each($img, function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  $element.addClass('fadein');
			} 
		  });

		   $.each($('section#shopify-section-template--21115362377816__custom_liquid_XcpgLB'), function() {
			var $element = $(this);
			var element_height = $element.outerHeight();
			var element_top_position = $element.offset().top;
			var element_bottom_position = (element_top_position + element_height);

			
			if ((element_bottom_position >= window_top_position) &&
				(element_top_position <= window_bottom_position)) {
			  	$aside.fadeOut(1000);
			} else{
				$aside.show();
			}
		  });
		
			
		}

		$window.on('scroll resize', check_if_in_view);
		$window.trigger('scroll');












     $('#additional-guest').on('change', function() {
        if ($(this).prop('checked')) {
            $('.add-guest-fields').show();
        } else {
            $('.add-guest-fields').hide();
        }
    });
});